import axios from "axios";
import { fixUrl } from '@/api/api.js'
import { message } from 'ant-design-vue'
// let token = JSON.parse(localStorage.getItem('tokenVal'))
import { getToken,  } from '@/utils/tools'



let service = axios.create({
    baseURL: fixUrl(''),
    timeout:30 * 1000,
    responseType:'json',
    headers: {
        'Content-Type': 'application/json',
        Authorization: 'Bearer ' + getToken(),
        a:1,
    },
})
// 请求拦截器
service.interceptors.request.use((config)=>{
    // token
    //密钥
    return config


},error =>{
    return Promise.reject(new Error(error))
})
// 响应拦截器
service.interceptors.response.use((res)=>{1
    const status = res.status  || 200
    const msg =  res.data.message || '未知错误'
    const response = res.data
    if (status == 401){
        message.error({
            content: () => '没有权限',
            class: 'message-error',
            duration:10000,
        })
        return Promise.reject(new Error(msg))
    }
    if (status != 200){
        message.error({
            content:msg,
            class: 'message-error'
        })
        return Promise.reject(new Error(msg))

    }
    return response

},error =>{
    message.error({
        content: '网络波动,请稍后再试！',
        class: 'message-error'
    })
    return Promise.reject(new Error(error))


})
export default service